import { render, staticRenderFns } from "./CourseTextView.vue?vue&type=template&id=56182ece&scoped=true"
import script from "./CourseTextView.vue?vue&type=script&lang=js"
export * from "./CourseTextView.vue?vue&type=script&lang=js"
import style0 from "./CourseTextView.vue?vue&type=style&index=0&id=56182ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56182ece",
  null
  
)

export default component.exports